module.exports = __webpack_public_path__ + "img/3bf42329e774ac36c5f2f3ad763040f1.png";